import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media } from 'util/style-helpers';

export const style: any = (styles?: IGenericObject) => {
  return StyleSheet.create({
    container: {
      display: 'flex',
      flexDirection: 'column',
      lineHeight: 1.375,

      [children('ul')]: {
        marginBottom: 20,
        listStylePosition: 'outside',
        paddingLeft: 0,
        marginLeft: 0,
      },
      [children('li')]: {
        listStyle: 'disc outside',
        marginLeft: '19px',
      },

      [media.tablet]: {
        marginBottom: 20,
      },
    },

    detailsContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 25,

      [media.tablet]: {
        alignItems: 'flex-start',
      },
    },

    imageContainer: {
      maxWidth: 260,
      flexBasis: '100%',

      [media.desktop]: {
        flex: '1 0 auto',
      },
    },

    infoContainer: {
      paddingLeft: 20,
      flexBasis: '100%',
      maxWidth: '50%',

      [media.tablet]: {
        flexBasis: 'auto',
        paddingLeft: 30,
        maxWidth: 'none',
      },
    },

    image: {
      marginBottom: 10,
    },

    name: {
      fontSize: 25,
      fontWeight: 500,
      marginBottom: 10,
    },
    title: {
      fontWeight: 500,
      fontSize: 20,
      lineHeight: 1.3,
      marginBottom: 5,
    },

    subtitle: {
      fontSize: '11px',
      color: '#707070',
    },

    lists: {},

    mobileLists: {
      display: 'block',

      [media.tablet]: {
        display: 'none',
      },
    },

    desktopLists: {
      display: 'none',

      [media.tablet]: {
        display: 'block',
      },
    },
  });
};
